// @ts-ignore immer intentionally exposes freeze but it's missing from the type definitions
import { freeze as immerFreeze } from 'immer';
export const freeze = immerFreeze;